import {Component, Inject, OnInit} from "@angular/core";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {FelloOfferJourneyType} from "fello-model";
import {take, tap} from "rxjs/operators";
import {last} from "lodash-es";

@Component({
  selector: "app-que-final-card",
  templateUrl: "./que-final-card.component.html",
  styleUrls: ["./que-final-card.component.scss"]
})
export class QueFinalCardComponent extends QuestionCardDirective implements OnInit {
  journeyType: FelloOfferJourneyType;
  FelloOfferJourneyType = FelloOfferJourneyType;

  constructor(offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super(offerJourneyService, taskId);
    this.journeyType = this.offerJourney.journeyType;
    offerJourneyService.markTaskAsLoading(taskId);
  }

  ngOnInit(): void {
    this.offerJourneyService.felloOfferJourney
      .pipe(
        take(1),
        tap(journey => {
          const lastTask = last(journey.userTrail);
          if (lastTask) {
            this.offerJourneyService.markTaskAsLoading(lastTask);
          }
        })
      )
      .subscribe();
    this.goToDashboard();
  }

  goToDashboard(): void {
    super.goToDashboard();
  }
}
